'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var React = require('react');
var HttpClient = require('@tunz/http');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var HttpClient__default = /*#__PURE__*/_interopDefaultLegacy(HttpClient);

const useRemoteData = (url) => {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const [data, setData] = React.useState();
    const performQuery = React.useCallback(() => _tslib.__awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const result = yield HttpClient__default["default"].get(url);
            setData(result.data);
        }
        catch (e) {
            setError(e.message);
        }
        finally {
            setLoading(false);
        }
    }), [url]);
    React.useEffect(() => {
        performQuery();
    }, [url]);
    return [loading, error, data, performQuery];
};

exports["default"] = useRemoteData;
